import axios from "axios";
import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const OrganizationService = {
  getList: async ({
    pageNumber,
    pageSize,
    statusFilter = "all",
    searchQuery = "",
  }) => {
    try {
      let url = `/organization?pageNumber=${pageNumber}&pageSize=${pageSize}`;

      // Add isPaid filter if status is not 'all'
      if (statusFilter !== "all") {
        url += `&isPaid=${statusFilter === "paid"}`;
      }

      // Add OrgName filter if searchQuery exists
      if (searchQuery.trim()) {
        url += `&OrgName=${encodeURIComponent(searchQuery)}`;
      }

      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getOrgList: async (pageNumber = 1, pageSize = 10000) => {
    try {
      const url = `/organization?pageNumber=${pageNumber}&pageSize=${pageSize}`;
      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async ({ data }) => {
    try {
      const response = await apiService.post(`/tenant/v2`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating tenant:", error);
      throw error;
    }
  },
  tenantDetail: async (id) => {
    const response = await apiService.get(`/tenantandorg/v2/${id}`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/organization/${id}`);
    return response.data;
  },
  orgDetail: async (id) => {
    const response = await apiService.get(`/organizationuser/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/organization/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  delete: async (id) => {
    const response = await apiService.delete(`/tenantandorg/v2/${id}`);
    return response.data;
  },

  // In OrganizationService.js
  setAsPaid: async (data) => {
    try {
      const response = await axios.post(`/organization/setaspaid`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  setAsHasOMS: async (data) => {
    try {
      const response = await axios.post(`/organization/setashasoms`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  setHasSalesScreen: async (data) => {
    try {
      const response = await axios.post(
        `/organization/sethassalesscreen`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

  createOrgDatabase: async ({ data }) => {
    console.log(data);
    try {
      const response = await apiService.post(
        `/organization/settenantinfo`,
        data
      );
      console.log(response);
      return response.data;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

  updateOrgDatabase: async ({ data, id }) => {
    try {
      const response = await apiService.put(`/tenantandorg/v2/${id}`, data);
      console.log(response);
      return response.data;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

  GetOrgDatabaseList: async () => {
    // console.log(data)
    try {
      const response = await apiService.get(`/tenantandorg/v2`);
      console.log(response);
      return response;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

  GetOrgDatabaseDetail: async (id) => {
    // console.log(data)
    try {
      const response = await apiService.get(`/tenantandorg/v2/${id}`);
      console.log(response);
      return response;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

  detailByCode: async (orgcode) => {
    const response = await apiService.get(
      "/detailsbyapicode/orgcode/orgdetail",
      {
        headers: {
          APIKEY: orgcode, // pass orgcode in header instead of query param
        },
      }
    );
    return response.data;
  },
  applyMigration: async (orgcode) => {
    try {
      const response = await apiService.post(`/databasemigration/tenant/${orgcode}/apply`);
      console.log(response);
      return response.data;
    } catch (error) {
      console.error("Error migrating:", error);
      throw error;
    }
  },
  dataSeed: async () => {
    try {
      const response = await apiService.post(`/configuration/seed-data`,{
         headers: {
               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
             },
      });
      return response.data;
    } catch (error) {
      console.error("Error seeding data:", error);
      throw error;
    }
  },
};

export default OrganizationService;
